import { render, staticRenderFns } from "./DistributionOfStartupCosts.vue?vue&type=template&id=3a0392b0"
import script from "./DistributionOfStartupCosts.vue?vue&type=script&lang=js"
export * from "./DistributionOfStartupCosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports